import Video from 'react-scale/components/elements/video';

export const TabVideo = ({ url = 'https://scaleai.wistia.com/medias/ieikkjioxr', poster = '' }) => {
  return (
    <Video
      className="xl:w-[649px] bg-black rounded-lg lg:w-[649px] lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-10 3xl:translate-x-18 transition-transform duration-1000 ease-out shadow-xl xl:shadow-super lg:max-w-[50%] xl:max-w-none lg:mb-0 mb-9 select-none"
      smallButton
      blackButton
      url={url}
      poster={poster}
    />
  );
};
